import React from 'react';
import { useIntl } from 'react-intl';
import { IconButton } from '../IconButton';

interface BannerDismissProps {
  onDismiss: () => void;
}

export const BannerDismiss: React.FC<BannerDismissProps> = ({ onDismiss }) => {
  const intl = useIntl();
  return (
    <IconButton
      data-component="BannerDismiss"
      iconName="close"
      onClick={onDismiss}
      title={intl.formatMessage({ defaultMessage: 'Close', id: 'rbrahO' })}
    />
  );
};
